import type {HelpFile} from '../../types/help'
import {WizardStepReviewSettingsTestIds} from '../../../testids/WizardStepReviewSettingsTestIds'

export const wizardStepReviewSettingsHelp: HelpFile = {
    docPage: '/docs/governance/certification-policies',
    texts: {
        [WizardStepReviewSettingsTestIds.selectReviewerType]:
            'Who receives the certification tasks — the manager, the profile owner, or the resource owner.',
        [WizardStepReviewSettingsTestIds.optionReviewerManager]: null,
        [WizardStepReviewSettingsTestIds.optionReviewerProfileOwner]: null,
        [WizardStepReviewSettingsTestIds.optionReviewerResourceOwner]: null,
        [WizardStepReviewSettingsTestIds.checkboxOverrideReviewFrequency]:
            'Leave off to use each access profile\'s own review frequency.',
        [WizardStepReviewSettingsTestIds.inputReviewFrequencyDays]: null,
        [WizardStepReviewSettingsTestIds.inputGracePeriodDays]:
            'Days after the due date before the non-response action fires.',
        [WizardStepReviewSettingsTestIds.selectNonResponseAction]:
            'What happens when a reviewer does not act before the grace period expires.',
        [WizardStepReviewSettingsTestIds.optionNonResponseNoChange]: null,
        [WizardStepReviewSettingsTestIds.optionNonResponseAutoRevoke]: null,
        [WizardStepReviewSettingsTestIds.optionNonResponseEscalate]: null,
        [WizardStepReviewSettingsTestIds.checkboxAutoRevokeOnOverdue]: null,
        [WizardStepReviewSettingsTestIds.comboboxCampaignOwner]:
            'Identity used as the staged campaign owner and fallback reviewer.',
    },
}
